import dayjs from "dayjs";

export const dateFields = {
  createdAt: "DD-MMM-YYYY HH:mm",
  updatedAt: "DD-MMM-YYYY HH:mm",
  deletedAt: "DD-MMM-YYYY HH:mm"
};

export const MONTHS = [...Array(12)].map((_, i) =>
  dayjs().month(i).format("MMM")
);

export const DATE_COLUMNS = [
  "dateFunded",
  "dueDate",
  "datePaid",
  "repaymentDate"
];
